import { getBreakpoints } from '../utils/utils';

class TripleBox {
  constructor() {
    this.titleHeight = 0;
    this.defaultTitleHeight = 'auto';
  }

  events() {
    // run even when the script executes after window load (delayed scripts)
    if (document.readyState === 'complete') {
      setTimeout(() => this.calculateDimensions(), 0);
    } else {
      window.addEventListener('load', () => {
        setTimeout(() => this.calculateDimensions(), 0);
      });
    }

    window.addEventListener('resize', () => this.calculateDimensions());
  }

  getMaxTitleHeight(items) {
    items.forEach((item) => {
      const title = item.querySelector('.c-title');
      if (title.getBoundingClientRect().height > this.titleHeight) {
        this.titleHeight = title.getBoundingClientRect().height;
      }
    });
  }

  setTitleHeight(items) {
    items.forEach((item) => {
      const title = item.querySelector('.c-title');
      title.style.height = `${this.titleHeight}px`;
    });
  }

  async resetHeight(items) {
    await items.forEach((item) => {
      const title = item.querySelector('.c-title');
      title.style.height = this.defaultTitleHeight;
    });
  }

  initCalcs(items) {
    this.resetHeight(items);
    this.getMaxTitleHeight(items);
    this.setTitleHeight(items);
  }

  initSliderBoxes(sliderBoxes) {
    sliderBoxes.forEach((sliderBox) => {
      this.titleHeight = 0;
      const items = sliderBox.querySelectorAll('.swiper-slide');
      this.initCalcs(items);
    });
  }

  initListingBoxes(listingBoxes) {
    listingBoxes.forEach((listingBox) => {
      this.titleHeight = 0;
      const items = listingBox.querySelectorAll('.listing-triple__celebration');
      this.initCalcs(items);
    });
  }

  calculateDimensions() {
    const sliderBoxes = document.querySelectorAll('.slider-box__list--celebration');
    const listingsTriple = document.querySelectorAll('.listing-triple--celebration');

    if (sliderBoxes.length > 0) {
      this.initSliderBoxes(sliderBoxes);
    }

    if (listingsTriple.length > 0 && window.innerWidth > getBreakpoints().md) {
      this.initListingBoxes(listingsTriple);
    }
  }
}

const TripleBoxObj = new TripleBox();
TripleBoxObj.events();
export default true;
